// Decimal hours -> "5h 14m" (a "5.232h" reading hides the minutes).
export function fmtHm(h) {
  if (h == null || h === "" || Number.isNaN(Number(h))) return "—";
  const m = Math.round(Number(h) * 60);
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`;
}
